import React from 'react';
import PropTypes from 'prop-types';
import { Card } from 'material-ui/Card';
import { ViewTitle, WithPermission } from 'admin-on-rest';
import { showNotification as showNotificationAction } from 'admin-on-rest';
import { connect } from 'react-redux';
import { push } from 'react-router-redux';
import get from 'lodash.get';
import fetcher from '../helpers/fetcher';
import { API_URL } from '../constants';
import CallScreenForm from './CallScreenForm';
import ProjectSelector from './ProjectSelector';
import { scrollToVisibleSelector } from '../helpers/dom';

class CallScreen extends React.Component {
  constructor(props) {
    super(props);
    this.state = this._getInitalState();
  }

  _getInitalState = () => {
    return {
      title: '...',
      contactId: null,
      projectId: null,
      formData: {
        call: {
          details: {
            start: new Date().toISOString()
          }
        }
      },
      callScreenFormData: {
        fields: []
      }
    };
  };

  _getContactId = () => {
    return get(this.props, 'match.params.id');
  };

  componentDidMount() {
    this._loadNextCall();
    // axios.get(API_URL + '/projects/latest').then(projectData => {
    //   this.setState({
    //     title: get(projectData, 'data.data.name'),
    //     callScreenFormData: get(
    //       projectData,
    //       'data.data.meta.callScreenFormData',
    //       {}
    //     )
    //     // schema: {
    //     //   type: 'object',
    //     //   properties: projectData.data.meta.fields.reduce((acc, field) => {
    //     //     acc[field.name] = field;
    //     //     return acc;
    //     //   }, {})
    //     // }
    //   });
    // });
  }

  componentWillUnmount() {
    clearTimeout(this.timeoutId);
  }

  _onDataLoad = (contact, isEdit) => {
    const contactData = get(contact, 'data', {});

    const projectData = get(contact, 'project', {});
    const callScreenFormData = get(projectData, 'meta.callScreenFormData', {});

    const formData = (callScreenFormData.fields || []).reduce((acc, field) => {
      acc[field.csvHeader] = contactData[field.csvHeader];
      if (acc[field.csvHeader] === null) {
        acc[field.csvHeader] = undefined;
      }
      return acc;
    }, {});

    formData.call = {
      details: {
        start: new Date().toISOString()
      }
    };

    formData.callbackDate = contact.callbackDate;
    formData.calls = contact.calls;
    formData.status = contact.status;

    if (isEdit) {
      const lastCall = contact.calls[contact.calls.length - 1];
      formData.calls = formData.calls.slice(0, -1);
      formData.call.status = lastCall.status;
      formData.call.details.subject = lastCall.details.subject;
      formData.call.details.comment = lastCall.details.comment;
      formData.call.details.callbackDate = lastCall.details.callbackDate;
      formData.call.details.start = lastCall.details.start;
      formData.call.details.duration = lastCall.details.duration;
    }

    this.setState({
      callScreenFormData,
      contactId: contact.id,
      projectId: projectData.id,
      title: projectData.name,
      // description: projectData.description,
      // script: projectData.script,
      formData
    });
  };

  _onResponseReceived = (res, isEdit) => {
    const contact = get(res, isEdit ? 'data.data' : 'data.data.[0]', {});
    this._onDataLoad(contact, isEdit);
    scrollToVisibleSelector('div.body');
  };

  _handleInvalidContact = () => {
    this.timeoutId = setTimeout(() => this.props.navigate('/call'), 10);
    this.props.showNotification(`Invalid contact requested`);
  };

  _loadNextCall = projectId => {
    if (!projectId || projectId === -1) {
      this.setState(this._getInitalState());
    }
    if (this._getContactId()) {
      fetcher
        .get(`${API_URL}/contacts/${this._getContactId()}?populate=project`)
        .then(res => {
          if (get(res, 'data.data.invalid_contact_id')) {
            this._handleInvalidContact();
            return;
          }
          this._onResponseReceived(res, true);
        })
        .catch(() => {
          this._handleInvalidContact();
        });
    } else {
      fetcher
        .get(`${API_URL}/projects/next`, {
          params: projectId ? { projectId } : {}
        })
        .then(res => {
          if (get(res, 'data.data.try_again')) {
            this.timeoutId = setTimeout(() => this._loadNextCall(), 100);
            return;
          }
          if (get(res, 'data.data.no_contact_for_now')) {
            const retrySeconds = 5;
            this.timeoutId = setTimeout(() => this._loadNextCall(), 5 * 1000);
            this.props.showNotification(
              `No contacts yet... will retry in ${retrySeconds} seconds`
            );
            this._onDataLoad({});
            return;
          }
          this._onResponseReceived(res);
        })
        .catch(() => {
          this.props.showNotification(
            `Can't get contact now. Please try again in a few seconds.`
          );
        });
    }
  };

  _onSubmit = () => {
    let url;
    let id;
    let isEdit = false;
    if (this._getContactId()) {
      isEdit = true;
      url = `${API_URL}/projects/call`;
      id = this._getContactId();
    } else {
      url = `${API_URL}/projects/call`;
      id = this.state.contactId;
    }
    return fetcher
      .post(
        url,
        {
          contactId: id,
          formData: this.state.formData
        },
        {
          validateStatus: status => {
            return (status >= 200 && status < 300) || status === 500;
          }
        }
      )
      .then(res => {
        if (res.status === 500) {
          if (res.data.code !== 'OK' && res.data.message) {
            throw new Error(res.data.message);
          }
          throw new Error('Other error');
        }
        this.props.showNotification(`Saved`);
        if (isEdit) {
          this.props.navigate('/call');
        } else {
          this._loadNextCall();
        }
      })
      .catch(e => {
        this.props.showNotification(
          `Can't save contact now. Please try again in a few seconds. ${(e &&
            e.message) ||
          ''}`
        );
      });
  };

  _onFormChange = data => {
    // console.log('_onCallScreenFormChange', data);

    const formData = { ...this.state.formData, ...data.formData };
    //if edit do not change the duration and remove last call from calls
    if (this._getContactId()) {
      const duration = get(this.state.formData, 'call.details.duration');
      if (duration) {
        formData.call.details.duration = duration;
      }
    }
    this.setState({
      formData
    });
  };

  _onProjectChange = id => {
    this._loadNextCall(id);
  };

  render() {
    return (
      <Card>
        <WithPermission value="agent">
          <ViewTitle title={this.state.title} />
        </WithPermission>
        <div className="bootstrap " style={{ margin: 20 }}>
          <WithPermission value="admin">
            <ProjectSelector
              onChange={this._onProjectChange}
              value={this.state.projectId}
            />
          </WithPermission>
          <CallScreenForm
            formData={this.state.formData}
            formSettings={this.state.callScreenFormData}
            onDataChange={this._onFormChange}
            onFormSubmit={this._onSubmit}
            modifyMode={!!this.props.contactId}
            isEditContact={this._getContactId()}
          />
        </div>
      </Card>
    );
  }
}

CallScreen.propTypes = {
  showNotification: PropTypes.func,
  contactId: PropTypes.number,
  match: PropTypes.shape({
    params: PropTypes.shape({
      id: PropTypes.string
    })
  }),
  navigate: PropTypes.func
};

export default connect(null, {
  showNotification: showNotificationAction,
  navigate: push
})(CallScreen);



// WEBPACK FOOTER //
// ./src/components/CallScreen.js